/**
 * Identifier of a timeline event inside a BlueConic profile
 */
export enum TimelineEventIds {
  RcActionPSI = "RC_Action_PSI",
  RcLoaded = "RC_Loaded",
  RcMorduBookmark = "RC_Mordu_Bookmark",
  RcMorduComment = "RC_Mordu_Comment",
  RcMorduScore = "RC_Mordu_Score",
  RcRead = "RC_Read",
  RcStartWebSession = "RC_Start_Web_Session",
  RcStreamedAudio = "RC_Streamed_Audio",
  RcStreamedVideo = "RC_Streamed_Video",
}
